import axios from "./axios";

export const getServerList = async (id) => {
  try {
    const data = await axios.get(`/api/v1/provision/servers/${id}`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const deleteServer = async (namespace, pod_name) => {
  try {
    const data = await axios.delete(`/api/v1/provision/servers/${namespace}/${pod_name}`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const listLogs = async (id, podName, container) => {
  try {
    const data = await axios.get(`/api/v1/provision/servers/${id}/${podName}?op=listLogs&container=${container}`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const download = async (id, podName, container, path, name) => {
  try {
    let url = `/api/v1/provision/servers/${id}/${podName}?op=download&container=${container}`;
    if (path) url += `&path=${path}&log=${name}`;
    else url += '&streamingLog=true';
    const data = await axios.get(url, {responseType: 'blob'});
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getFileContent = async (id, podName, container, path) => {
  try {
    const data = await axios.get(`/api/v1/provision/servers/${id}/${podName}?op=getFileContent&container=${container}&path=${path}`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const listFiles = async (id, podName, container, path) => {
  try {
    const data = await axios.get(`/api/v1/provision/servers/${id}/${podName}?op=listFiles&container=${container}&path=${path}`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const describePod = async (id, podName) => {
  try {
    const data = await axios.get(`/api/v1/provision/servers/${id}/${podName}?op=describe`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};